export default __webpack_public_path__ + "static/media/portfolio-65.5baf89c2.jpg";